/* eslint-disable react/no-children-prop */
import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

import ProductView from '../components/Product/View';
import Modal from '../components/Modal';
import PageLoader from '../components/Loader';
import ProtectedRoutes from './ProtectedRoutes';
import PrivateRoutes from './PrivateRoutes';

const Layout = lazy(async () => import('../components/Layout'));
const AuthLayout = lazy(async () => import('../components/Layout/Auth'));

const Products = lazy(async () => import('../pages/Products'));
const Collections = lazy(async () => import('../pages/Collections'));
const Collection = lazy(async () => import('../pages/Collection'));
const Order = lazy(async () => import('../pages/Order'));
const SignIn = lazy(async () => import('../pages/Auth/SignIn'));
const SignUp = lazy(async () => import('../pages/Auth/SignUp'));
const SignUpFeedback = lazy(async () =>
  import('../pages/Auth/SignUp/Feedback'),
);
const SignUpApproved = lazy(async () =>
  import('../pages/Auth/SignUp/Approved'),
);
const SignUpError = lazy(async () => import('../pages/Auth/SignUp/Error'));
const ForgotPassword = lazy(async () => import('../pages/Auth/PasswordReset'));
const ResetPassword = lazy(async () =>
  import('../pages/Auth/PasswordReset/Reset'),
);
const PasswordResetSent = lazy(async () =>
  import('../pages/Auth/PasswordReset/Sent'),
);
const PasswordResetDone = lazy(async () =>
  import('../pages/Auth/PasswordReset/Done'),
);
const Profile = lazy(async () => import('../pages/Account/Profile'));
const Dealers = lazy(async () => import('../pages/Account/Dealers'));
const Orders = lazy(async () => import('../pages/Account/Orders'));
const ViewOrder = lazy(async () => import('../pages/Account/Orders/View'));

const MyRoutes = () => (
  <React.Suspense fallback={<PageLoader />}>
    <Routes>
      <Route path="/" element={<ProtectedRoutes />}>
        <Route path="/" element={<Layout />}>
          <Route index element={<Products />} />
          <Route path="/products/:collection" exact element={<Products />} />
          <Route path="/collections" exact element={<Collections />} />
          <Route
            path="/collections/:collectionId/:slug"
            exact
            element={<Collection />}
          />
          <Route path="/order" exact element={<Order />} />

          <Route path="/account">
            <Route path="profile" exact element={<Profile />} />
            <Route path="orders" exact element={<Orders />} />
            <Route path="orders/:id" exact element={<ViewOrder />} />
            <Route path="" element={<PrivateRoutes />}>
              <Route path="dealers" exact element={<Dealers />} />
            </Route>
          </Route>
        </Route>
      </Route>
    </Routes>
    <Routes>
      <Route
        path="/products/:id"
        element={<Modal content={<ProductView />} />}
      />
    </Routes>
    <Routes>
      <Route path="/auth" element={<AuthLayout />}>
        <Route path="signin" element={<SignIn />} />
        <Route path="signup" exact element={<SignUp />} />
        <Route path="signup/ok" element={<SignUpFeedback />} />
        <Route path="signup/approved" element={<SignUpApproved />} />
        <Route path="signup/invalid" element={<SignUpError />} />
        <Route path="reset-password" exact element={<ForgotPassword />} />
        <Route path="reset-password/reset" element={<ResetPassword />} />
        <Route path="reset-password/sent" element={<PasswordResetSent />} />
        <Route path="reset-password/done" element={<PasswordResetDone />} />
      </Route>
    </Routes>
  </React.Suspense>
);
export default MyRoutes;
